import React, { useCallback } from 'react';
import { createUseStyles, Input } from '@Sage/hoi-poi-ui';
import Size from "./Size";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'WidgetSize');
function WidgetSize(_ref) {
  let {
    onChange,
    value = {
      columns: 2,
      rows: 1
    }
  } = _ref;
  const classes = useStyles();
  var _ref2 = /*#__PURE__*/React.createElement(Size, {
    column: 2,
    row: 1,
    onChange: onChange,
    value: value
  });
  var _ref3 = /*#__PURE__*/React.createElement(Size, {
    column: 2,
    row: 2,
    onChange: onChange,
    value: value
  });
  var _ref4 = /*#__PURE__*/React.createElement(Size, {
    column: 3,
    row: 1,
    onChange: onChange,
    value: value
  });
  var _ref5 = /*#__PURE__*/React.createElement(Size, {
    column: 3,
    row: 2,
    onChange: onChange,
    value: value
  });
  const component = useCallback(() => /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, _ref2, _ref3, _ref4, _ref5), [classes.root, onChange, value]);
  return /*#__PURE__*/React.createElement(Input, {
    component: component,
    className: classes.input
  });
}
export default WidgetSize;